export enum ActiveRegionStyle {
  OUTLINE,
  HIGHLIGHT,
}
